import React, { useState } from 'react';
import Modal from './Modal';
import { Product } from '../types';

interface ProductActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: Product;
  onIncrease: (id: string, amount: number) => void;
  onDecrease: (id: string, amount: number) => void;
}

const ProductActionModal: React.FC<ProductActionModalProps> = ({
  isOpen,
  onClose,
  product,
  onIncrease,
  onDecrease
}) => {
  const [amount, setAmount] = useState(1);

  const handleIncrease = () => {
    onIncrease(product.id, amount);
    onClose();
  };

  const handleDecrease = () => {
    onDecrease(product.id, amount);
    onClose();
  };

  const incrementAmount = () => {
    setAmount(prev => prev + 1);
  };

  const decrementAmount = () => {
    setAmount(prev => Math.max(1, prev - 1));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="product-action-modal">
        <h2>Scanned product</h2>
        
        <div className="product-info">
          <p className="product-name"><strong>{product.name}</strong></p>
          <p><strong>ID:</strong> {product.id}</p>
          {product.expiryDate && <p><strong>Expiry date:</strong> {product.expiryDate}</p>}
          <p><strong>Current quantity:</strong> {product.quantity}</p>
        </div>
        
        <div className="form-group">
          <label htmlFor="action-amount">Choose quantity:</label>
          <div className="quantity-control">
            <button 
              className="quantity-btn" 
              onClick={decrementAmount}
              disabled={amount <= 1}
            >
              -
            </button>
            <input
              type="number"
              id="action-amount"
              className="form-control"
              value={amount}
              min="1"
              onChange={(e) => setAmount(Math.max(1, parseInt(e.target.value) || 0))}
            />
            <button 
              className="quantity-btn" 
              onClick={incrementAmount}
            >
              +
            </button>
          </div>
        </div>
        
        <p className="action-question">What do you want to do with this product?</p>
        
        <div className="action-buttons">
          <button 
            className="btn btn-success" 
            onClick={handleIncrease}
          >
            Add more ({amount} pcs)
          </button>
          
          <button 
            className="btn btn-warning" 
            onClick={handleDecrease}
            disabled={product.quantity <= 0}
          >
            Consume product ({amount} pcs)
          </button>
          
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProductActionModal; 